var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-pv-receipt"},[_c('Receipt',{attrs:{"receiptId":_vm.receiptId,"admin":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }